"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatMessage = void 0;
var account_1 = require("../account");
var chat_thread_1 = require("./chat-thread");
var chat_message_type_enum_1 = require("./enums/chat-message-type-enum");
var ChatMessageDateProperties = ['created_at', 'updated_at'];
var ChatMessage = /** @class */function () {
  function ChatMessage(values) {
    if (values === void 0) {
      values = {};
    }
    /** Тип сообщения */
    this.type = chat_message_type_enum_1.ChatMessageTypeEnum.plain;
    var properties = Object.keys(values);
    var instance = this;
    properties.forEach(function (p) {
      instance[p] = values[p];
      if (ChatMessageDateProperties.includes(p) && values[p]) {
        instance[p] = new Date(values[p].toString());
      }
    });
    if (values.thread) {
      instance.thread = new chat_thread_1.ChatThread(values.thread);
    }
    if (values.author) {
      instance.author = new account_1.User(values.author);
    }
    if (values.reply_user) {
      instance.reply_user = new account_1.User(values.reply_user);
    }
    return this;
  }
  return ChatMessage;
}();
exports.ChatMessage = ChatMessage;
